import { useCallback } from "react";
import { useSetAtom } from "jotai";
import { Toast, toastAtom } from "../atoms/toast.atom";

export const useToast = () => {
  const setToast = useSetAtom(toastAtom);

  const toast = useCallback(
    (toast: Toast) => {
      setToast((toasts) => [...toasts, toast]);
    },
    [setToast]
  );

  return toast;
};
